import { render, staticRenderFns } from "./GraduateImportReview.vue?vue&type=template&id=fb1170c4&scoped=true"
import script from "./GraduateImportReview.vue?vue&type=script&lang=js"
export * from "./GraduateImportReview.vue?vue&type=script&lang=js"
import style0 from "./GraduateImportReview.vue?vue&type=style&index=0&id=fb1170c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1170c4",
  null
  
)

export default component.exports